export default __webpack_public_path__ + "static/media/uploader-abbottLite-2.81e0ee74.png";